export const SHOW_SIDE_BAR_SET = 'SHOW_SIDE_BAR_SET';
export const HIDE_SIDE_BAR_SET = 'HIDE_SIDE_BAR_SET';

export const WINDOW_RESIZE_SET = 'WINDOW_RESIZE_SET';
export const ACTIVE_TAB_SET = 'ACTIVE_TAB_SET';
